import { useSelector } from 'react-redux'

import Warning from '@/components/util/feedback/Warning'
import { getDeviceOrder } from '@/ducks/deviceOrderReducer'

import './device-order-dealer-instructions.scss'

const DeviceOrderDealerInstructions = () => {
  const { dealer_instructions } = useSelector(getDeviceOrder)

  if (dealer_instructions?.trim()) return null

  return <Warning className="device-order-dealer-instructions">{dealer_instructions}</Warning>
}

export default DeviceOrderDealerInstructions
